// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/sequence_editor/templates/sequences.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_attrs0 = {
        "class": "widget-with-controls widget-controls-horiz"
      },
    marko_attrs1 = {
        "class": "list-container"
      },
    marko_attrs2 = {
        "class": "sequence"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("129d9c"),
    marko_node0 = marko_createElement("div", {
        "class": "sequence-top-padding"
      }, "3", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", null, null, null, 0),
    marko_node1 = marko_createElement("div", {
        "class": "sequence-bottom-padding"
      }, "10", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", null, null, null, 0),
    marko_node2 = marko_createElement("div", {
        "class": "widget-controls sequence-controls"
      }, "12", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "control-panel"
        }, null, null, 1)
        .e("div", {
            "class": "control-group"
          }, null, null, 6)
          .e("div", {
              "class": "control"
            }, null, null, 1)
            .e("button", {
                id: "add-pattern"
              }, null, null, 1)
              .e("i", {
                  "class": "far fa-plus-square"
                }, null, null, 0)
          .e("div", {
              "class": "control"
            }, null, null, 1)
            .e("button", {
                id: "delete-pattern"
              }, null, null, 1)
              .e("i", {
                  "class": "far fa-minus-square"
                }, null, null, 0)
          .e("div", {
              "class": "control"
            }, null, null, 1)
            .e("button", {
                id: "pattern-up"
              }, null, null, 1)
              .e("i", {
                  "class": "fa fa-caret-right"
                }, null, null, 0)
          .e("div", {
              "class": "control"
            }, null, null, 1)
            .e("button", {
                id: "pattern-down"
              }, null, null, 1)
              .e("i", {
                  "class": "fa fa-caret-left"
                }, null, null, 0)
          .e("div", {
              "class": "control"
            }, null, null, 1)
            .e("button", {
                id: "duplicate-pattern"
              }, null, null, 1)
              .e("i", {
                  "class": "fa fa-redo-alt"
                }, null, null, 0)
          .e("div", {
              "class": "control"
            }, null, null, 1)
            .e("button", {
                id: "clone-pattern"
              }, null, null, 1)
              .e("i", {
                  "class": "far fa-clone"
                }, null, null, 0),
    marko_attrs3 = {
        "class": "sequence-index"
      },
    marko_attrs4 = {
        "class": "sequence-pattern"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("div", marko_attrs1, "1", component);

  out.be("div", marko_attrs2, "2", component);

  out.n(marko_node0, component);

  var $for$0 = 0;

  marko_forIn(data.sequence, function(p, index) {
    var $keyScope$0 = "[" + (($for$0++) + "]");

    out.e("div", {
        "class": marko_classValue({
            "sequence-row": true,
            "current-pattern": data.cursor.sequence === index
          }),
        "data-sequenceindex": "" + index
      }, "5" + $keyScope$0, component, 2)
      .e("div", marko_attrs3, "6" + $keyScope$0, component, 1)
        .e("div", null, "7" + $keyScope$0, component, 1)
          .t(index, component)
      .e("div", marko_attrs4, "8" + $keyScope$0, component, 1)
        .e("div", null, "9" + $keyScope$0, component, 1)
          .t(p, component);
  });

  out.n(marko_node1, component);

  out.ee();

  out.ee();

  out.n(marko_node2, component);

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
